import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ThumbsDownFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M16 15.3333H20V3.99996H16V5.33329V13.6666V15.3333ZM14.6667 13.6666L14.6667 5.33329H7.87925C6.75228 5.33329 5.74698 6.04175 5.36794 7.10306L3.93937 11.1031C3.31914 12.8397 4.6066 14.6666 6.45068 14.6666H10L8.80283 18.9764C8.56683 19.826 9.20576 20.6666 10.0875 20.6666H10.6667L14.6667 13.6666Z"
        fill={iconColor}
      />
    </Svg>
  );
}
